// Add your custom JS here.
jQuery(function($){
    $(window).load(function() {
      $('#productgallery').flexslider();
      $('#kitimg').flexslider();



      $('#shedgallery-carousel').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        itemWidth: 210,
        itemMargin: 5,
        asNavFor: '#shedgallery'
      });
     
      $('#shedgallery').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        sync: "#shedgallery-carousel"
      });


      $('#life-slider figure.wp-block-image, #life-carousel figure.wp-block-image, #gallery-life figure.wp-block-image').replaceWith(function() {
        var tag_class = $(this).attr("class");
        var tag_id = $(this).attr("id");
        
        if ( tag_class == null) {
          var tag_class_plus =[];
        } else {
          var tag_class_plus = 'class="'+tag_class+'"';
        }
        if ( tag_id == null ) {
          var tag_id_plus =[];
        } else {
          var tag_id_plus = 'id="'+tag_id+'"';
        }
        $(this).replaceWith('<li '+tag_id_plus+'  '+tag_class_plus+'>'+$(this).html()+'</li>');
      });



      $('#life-carousel, #life-slider, #gallery-life').replaceWith(function() {
        var tag_class = $(this).attr("class");
        var tag_id = $(this).attr("id");
        
        if ( tag_class == null) {
          var tag_class_plus =[];
        } else {
          var tag_class_plus = 'class="'+tag_class+'"';
        }
        if ( tag_id == null ) {
          var tag_id_plus =[];
        } else {
          var tag_id_plus = 'id="'+tag_id+'"';
        }
        $(this).replaceWith('<div '+tag_id_plus+' class="flexslider"><ul '+tag_class_plus+'>'+$(this).html()+'</ul></div>');
      });


  $('#life-carousel').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 90,
    itemMargin: 5,
    asNavFor: '#life-slider'
  });
 
  $('#life-slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: "#life-carousel"
  });



  $('#gallery-life').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 160,
    itemMargin: 5,
  });


    });
});


jQuery(function($) {

  if ($(window).width() < 992) {
    $(".dropdown-toggle").attr('data-toggle', 'dropdown').attr('data-bs-toggle', 'dropdown').attr('href', '#').removeAttr('data-hover').removeAttr('data-bs-hover');
  } else {
    $(".dropdown-toggle").removeAttr('data-toggle').removeAttr('data-bs-toggle');
  }
  
  var timer = '';
  $(window).resize(function() {

    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function(){

    if ($(window).width() < 992) {
      $(".dropdown-toggle").attr('data-toggle', 'dropdown').attr('data-bs-toggle', 'dropdown').attr('href', '#').removeAttr('data-hover').removeAttr('data-bs-hover');
    } else {
      $(".dropdown-toggle").removeAttr('data-toggle').removeAttr('data-bs-toggle');
    }
  }, 200);
  });
});